import { AppState, Dispatch } from '../../types';
import { connect } from 'react-redux';
import { RawDataPage, Props, EventProps, ExternalProps } from './RawDataPage';
import * as selectors from './selectors'
import * as actions from './actions'
import { selectors as authSelectors } from '../../lifecycle/auth';
import { Environment } from '../../remote-api/models';
import {
  baseRawDataOptions,
  rawDataSelectorOptions,
  selectEnvironmentAndFetchAllResources,
  selectResourceAndFetchTargets
} from './actions';
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource';
import { Resource } from '../../common/resource/model';
import { BasicTarget } from '../../common/resource/target/model';

const mapProps = (state: AppState, ownProps: ExternalProps): Props => ({
  ...ownProps,
  organizationId: authSelectors.getOrganizationId(state),
  authorization: authSelectors.getAuthorization(state),
  isLoading: selectors.getIsLoading(state),
  logFiles: selectors.getLogFiles(state),
  environmentSelector: selectors.getEnvironmentSelector.getAll(state),
  resourceSelector: selectors.getResourceSelector.getAll(state),
  targetsSelector: selectors.getTargetsSelector.getAll(state),
});

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  load: (props: ExternalProps) => dispatch(actions.onLoad(props)),
  onView: (props: ExternalProps) => actions.onView(props),
  changeSelectedDate: (selectedDate: string) => dispatch(actions.changeSelectedDate(selectedDate)),
  downloadLogFile: (fileKey: string) => dispatch(actions.downloadLogFile(fileKey)),
  environmentSelected: (environmentId: string, environments?: Environment[]) =>
    dispatch(selectEnvironmentAndFetchAllResources(rawDataSelectorOptions(baseRawDataOptions), environmentId, environments)),
  resourceSelected: (resourceId: string, resourceType: ResourceType, resources?: Resource[]) =>
      dispatch(selectResourceAndFetchTargets(rawDataSelectorOptions({...baseRawDataOptions, resourceType}), resourceId, resources)),
  onTargetsChange: (targets: BasicTarget[]) => dispatch(actions.onTargetsChange(targets)),
});

export default connect(mapProps, mapDispatch)(RawDataPage)
